import { Providers } from "@microsoft/mgt-react";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addGroup, selectGroup } from "../Store/MgtSlice";

export const GroupWithSuspense = ({ groupId }) => {
  const [group, setGroup] = useState(null);
  const [provider, setProvider] = useState(Providers.globalProvider);
  const dispatch = useDispatch();
  const reduxGroup = useSelector((state) => selectGroup(state, { groupId }));

  useEffect(() => {
    Providers.onProviderUpdated(() => {
      setProvider(Providers.globalProvider);
    });

    return () => {
      Providers.removeProviderUpdatedListener(() => {
        setProvider(Providers.globalProvider);
      });
    };
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      if (provider) {
        if (reduxGroup) {
          setGroup(JSON.stringify(reduxGroup));
          return;
        }
        try {
          const client = provider.graph;
          const group = await client.api(`/groups/${groupId}`).get();
          dispatch(addGroup(group));
          setGroup(JSON.stringify(group));
        } catch (error) {
          console.error(error);
        }
      }
    };

    fetchUser().catch((error) => {
      console.error(error);
    });
  }, [groupId, provider]);

  if (!provider || !group) {
    return null;
  }

  return (
    <Suspense
      fallback={<div>Loading...</div>}
      id={group}
    >
      <mgt-person
        person-details={group}
        person-card="click"
        view="oneline"
      />
    </Suspense>
  );
};

export default GroupWithSuspense;
